export const localStorage = {
    get(key) {
        const item = window.localStorage?.getItem(key);
        try {
            return item ? JSON.parse(item) : null;
        }
        catch {
            return item;
        }
    },
    set(key, value) {
        try {
            const item = JSON.stringify(value);
            window.localStorage.setItem(key, item);
        }
        catch {
        }
    },
    remove(key) {
        window.localStorage?.removeItem(key);
    },
    getOrSetDefault(key, defaultValue) {
        const item = this.get(key);
        if (item === null || item === undefined) {
            this.set(key, defaultValue);
            return defaultValue;
        }
        return item;
    },
};
